<template>
  <div class="content">
    <div id="blogPost">
      <div v-if="showBlog" class="blog-holder">
        <div v-if="showBlog" class="blogImg" :style="'background-image: url(' + blogThumbnail + ')'">
        </div>
        <div class="blogTitle">
          <h2>{{ blogTitle }}</h2>
        </div>
        <div class="blogContent">
          <div class="blogDescription">
            <p v-html="blogContent"></p>
          </div>
          <div class="blogDate">
            <div class="date">Published on: {{ formatDate(blogCreatedAt) }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <h4 class="error">ooops - we can't find that blog</h4>
      </div>
    </div>
  </div>
</template>


<script setup>
import { ref, onMounted, computed } from "vue";
import axios from "axios";

// get blog url to compare against
const currentUrl = window.location.href;
const match = currentUrl.match(/\/blog\/(.*)/);
const siteId = process.env.VUE_APP_SITE_ID;


// Define reactive variables
let blogTitle = ref("");
let blogContent = ref("");
let blogThumbnail = ref("");
let blogCreatedAt = ref("");
let showBlog = ref(true);
let blogUrl = ref(null);

// The function to load blog data
async function loadBlogData() {

  try {
    const response = await axios.get('https://supasmart.co.uk/api/blogs/' + siteId + '/' + blogUrl);
    const blog = response.data;

    if (blog) {
      blogTitle.value = blog.name;
      blogContent.value = blog.content;
      blogThumbnail.value = window.innerWidth <= 640 ? blog.image_mobile || blog.image_desktop : blog.image_desktop;
      blogCreatedAt.value = blog.created_at;
    } else {
      showBlog.value = false;
    }
  } catch (error) {
    showBlog.value = false;
    console.error("Error loading blog data:", error);
  }
}

// Method to format the date into DD/MM/YYYY
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  return date.toLocaleDateString("en-GB", options);
};

onMounted(() => {

  if (match != null) {
    blogUrl = match[1];
    loadBlogData();
  }

});
</script>

<style>
.blog-holder {
  width: 100%;
}

.error {
  padding: 2em 0;
}

body:has(#blog, #blog-item) {
  background: #fff2d7;
}
</style>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 0 20px;
}

#blogPost {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  max-width: 1000px;
  margin: 100px 20px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #faefdf;

  .blogTitle {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding: 2% 5%;
    border-bottom: 1px solid #faefdf;
  }

  .blogImg {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #faefdf;
    background-size: cover;
    background-position: center;

    img {
      width: 100%;
    }
  }

  .blogContent {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    min-height: 36vh;

    .blogDescription {
      width: calc(100% - 10%);
      margin: 5%;
    }

    .blogDate {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;
      padding: 2% 5%;
      border-top: 1px solid #faefdf;
      background: #ffe1bd;
    }
  }
}

.blog-holder {
  width: 100%;
}

.error {
  padding: 2em 0;
}

body:has(#blog, #blog-item) {
  background: #fef9ef !important;
}

@media (max-width: 840px) {
  .content {
    padding: 0 20px 0;
  }

  #blogPost .blogImg {
    height: 200px;
  }
}
</style>
